/**
 * A filled sample of what a webhook sends: the builder shows it under the
 * address, and "Send a test" posts it. One source, so the two never drift.
 */
export function sampleHandoff(nowSec: number): Record<string, unknown> {
  return {
    id: "wh_sample",
    event: "clicked-offer",
    occurred_at: nowSec,
    workspace_id: "ws_sample",
    person: {
      id: "reg_sample",
      name: "Sample Person",
      email: "sample@example.com",
      first_name: "Sample",
      last_name: "Person",
      phone: null,
      registered_at: nowSec - 86_400,
      plan: null,
      attribution: {
        utm_source: "facebook",
        utm_medium: "paid",
        utm_campaign: "spring-webinar",
        utm_content: "video-a",
        utm_term: null,
        fbclid: "IwAR_sample",
        gclid: null,
        li_fat_id: null,
        ttclid: null,
        msclkid: null,
        gbraid: null,
        wbraid: null,
        landing: "/sample-webinar?utm_source=facebook&utm_medium=paid&utm_campaign=spring-webinar",
        first_seen: nowSec - 90_000,
        source: "facebook",
      },
    },
    webinar: { id: "web_sample", title: "Sample Webinar", slug: "sample-webinar", session_at: null },
    answers: [
      {
        interaction_id: "int_sample",
        type: "poll",
        question: "How soon are you looking to move?",
        value: { kind: "poll", option: "In 3 months" },
      },
    ],
    tags: ["clicked-offer", "reached-offer", "registered", "watched"],
    trigger: { type: "tag_added", tag: "clicked-offer" },
    automation: { id: "auto_sample", name: "Sample automation" },
    watch: { pct: 62, minutes: 41, completed: false, stopped: false, last_active_at: nowSec - 600 },
    offer: { reached: true, reached_at: nowSec - 900, clicked: true, clicked_at: nowSec - 60 },
    links: {
      room: "https://sample.flashsuite.net/watch/wt_sample",
      watch_page: "https://sample.flashsuite.net/w/sample-webinar/watch?t=wt_sample",
    },
  };
}
